<template>
  <!-- <h4>这是登录成功显示在账号下面的内容区</h4> -->
  <div class="full-height">
    <router-view />
  </div>
</template>
<script>
import { createMeta } from './meta.js';

export default {
  meta() {
    return createMeta(this);
  },
  created() {
    // const url = this.$route.params.store;
    // if (!(this.userInfo && this.userInfo.email && this.userInfo.nickName)) {
    //   this.$router.push({ path: `/${url}/user-info` });
    // }
    // else {
    //   this.$router.push({ path: `/${url}/user/order-history` });
    // }
  },
  mounted() {
    this.$q.cookies.remove('translate');
  },
};
</script>
